import { render, staticRenderFns } from "./RecommendationOrderFilters.vue?vue&type=template&id=0b19a45a"
import script from "./RecommendationOrderFilters.vue?vue&type=script&lang=js"
export * from "./RecommendationOrderFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports